import React, { Fragment } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Tourism = () => {

    return (
        <Fragment>
            <Header />
            <div class="breadcumb-wrapper" style={{ background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),  url('/assets/img/added/ban.jpg')" }}>
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">General Tourism</h1>
                        <div class="breadcumb-menu-wrap">
                            <ul class="breadcumb-menu">
                                <li><a href="/">Home</a></li>
                                <li>General Tourism</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section class="space">
                <div class="container">
                    <div class="row align-items-center sprituality-box">
                        <div class="col-lg-12">
                            <div class="about-content sprituality-content text-center">
                                <div class="title-area">
                                    <span class="sec-subtitle">See the places you`ve heard about without rushing through them</span>
                                    <h2 class="sec-title h1">Go Beyond the Checklist</h2>
                                    <p class="sec-text">This isn`t about packing ten monuments into a day. It`s about really seeing a place, taking your time, and noticing the little things  a conversation with a chai seller, quiet streets at sunrise, or the smell of fresh parathas in an old city.</p>
                                    <p class="sec-text">We visit India`s most beautiful and historic places, but without the typical tourist approach. You`ll get to explore, learn, taste, and enjoy  with enough space in between to breathe and just take it all in.</p>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="about-content sprituality-content">
                                <div class="title-area">
                                    <p class="sec-text"><b>What to Expect</b></p>
                                    <p class="sec-text">We`ll guide you through cities, towns, and landscapes that show you the richness of India  its colors, chaos, calm, and contrasts. But we don`t rush. You`ll visit forts, palaces, markets, temples, nature spots, and local homes  not just with a guidebook, but with context and time.</p>
                                    <p class="sec-text">Think: meaningful conversations, relaxed walks, local food, and time to sit still when you feel like it.</p>
                                </div>
                                <p class="sec-text"><b>Who Is This For?</b></p>
                                <ul class="about-list1">
                                    <li>People who want to explore India without feeling like a tourist</li>
                                    <li>First-time visitors who want the famous places, but at a slower pace</li>
                                    <li>Travelers who care more about experience than photo checklists</li>
                                    <li>Anyone curious about daily Indian life beyond monuments</li>
                                </ul>
                                <a href="destination" class="vs-btn style4">Know More</a>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="image-box1">
                                <img class="img1" src="assets/img/added/tourism.png" alt="image1" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

           
            <Footer />
        </Fragment>
    );
}

export default Tourism;